<template>
  <v-row wrap class="pa-5">
    <v-col cols="12" md="12" sm="12">
      <v-btn :outlined="tab === 'setuju'" large class="mr-1" color="primary" @click="onChangeTab('ajuan')">
        <v-icon left>mdi-briefcase</v-icon> AJUAN CUTI
      </v-btn>
      <v-btn :outlined="tab === 'ajuan'" large color="primary" @click="onChangeTab('setuju')">
        <v-icon left>mdi-briefcase-check</v-icon> Persetujuan Cuti
      </v-btn>
    </v-col>
    <v-col cols="12" :md="tab === 'ajuan' ? 8 : 12" sm="12">
      <m-card-list
        two-line
        :title="tab === 'ajuan' ? 'Cuti Anggota' : 'Persetujuan Cuti'"
        :labelCari="tab === 'ajuan' ? 'Cari Ajuan' : 'Cari Pengajuan'"
        :add="isCan('cuti-ajuan.store') && tab === 'ajuan'"
        :search="tab === 'ajuan'"
        :items="items"
        :headers="headers"
        @filter="filter"
        refresh
        @refresh="load"
        filterWaktu
        :page="page"
        footer
        @search="
          (search) => {
            textSearch = search
            load()
          }
        "
        @change:page="
          (pg) => {
            cp = pg
            load()
          }
        "
        @add="add"
      >
        <template v-slot:action_tools>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" depressed small class="rounded mr-3 pa-5 grey lighten-3" icon @click="onFilter">
                <v-icon>mdi-filter</v-icon>
              </v-btn>
            </template>
            <span>Filter Ajuan</span>
          </v-tooltip>
        </template>
        <template v-slot:items="{ props, item }">
          <tr v-if="tab === 'ajuan'">
            <td>
              {{ mKategoriCuti && mKategoriCuti[Number(item.cuti_kategori_id)] }}
              <div class="caption grey--text">
                {{ duration(getDeepObj(item, 'tgl_awal'), getDeepObj(item, 'tgl_akhir')) }} &nbsp;
                {{ countDate(getDeepObj(item, 'tgl_awal'), getDeepObj(item, 'tgl_akhir')) }} Hari
              </div>
            </td>
            <td>
              <div> {{ getDeepObj(item, 'keterangan') }}<br /> </div>
            </td>
            <td>
              <v-chip small outlined :color="mStatus[item.k_status]['color']">
                {{ mStatus[item.k_status]['label'] }}
              </v-chip>
            </td>
            <td>{{ getDeepObj(item, 'created_at') | toDT }}</td>
            <td>
              <m-menu left style="float: right" :items="more_menu" :object="item" />
            </td>
          </tr>
          <tr v-else>
            <td> {{ getDeepObj(item, 'cuti.users.nama') }}<br /> </td>
            <td>
              {{
                getDeepObj(item, 'cuti.cuti_kategori.nama') ||
                  (mKategoriCuti && mKategoriCuti[Number(item.cuti_kategori_id)])
              }}
              <div class="caption grey--text">
                {{ duration(getDeepObj(item, 'cuti.tgl_awal'), getDeepObj(item, 'cuti.tgl_akhir')) }} &nbsp;
                {{ countDate(getDeepObj(item, 'cuti.tgl_awal'), getDeepObj(item, 'cuti.tgl_akhir')) }} Hari
              </div>
            </td>
            <td>
              <div>
                {{ getDeepObj(item, 'cuti.keterangan') || getDeepObj(item, 'cuti.cuti_kategori.nama') }}
              </div>
            </td>
            <td>
              <v-chip v-if="Number(item.cuti.k_status) === 8" small outlined :color="mStatus[8]['color']">
                {{ mStatus[8]['label'] }}
              </v-chip>
              <v-chip v-else small outlined :color="mStatus[item.k_status]['color']">
                {{ mStatus[item.k_status]['label'] }}
              </v-chip>
            </td>
            <td>
              {{ getDeepObj(item, 'wkt_ajuan') | toDT }}
            </td>
            <td>
              <m-menu left style="float: right" :items="more_menu" :object="item" />
            </td>
          </tr>
        </template>
      </m-card-list>
    </v-col>
    <v-col v-if="tab === 'ajuan'" cols="12" md="4" sm="12">
      <v-card>
        <v-card-text>
          <h2>Saldo Cuti</h2>

          <div v-for="(saldo, s) in saldos" :key="s" class="mt-2">
            <div class="d-flex justify-space-between">
              <span class="font-weight-bold">{{ saldo.nama }}</span>
              <span v-if="Number(saldo.is_saldo) === 1" class="caption text--primary">{{ saldo.total }} hari</span>
              <span v-else class="caption text--primary">Maks {{ saldo.maks_ajuan || 0 }} hari</span>
            </div>
            <v-progress-linear
              :value="Number(saldo.is_saldo) === 1 ? saldo.value : 100"
              rounded
              height="13"
              color="primary"
            />
            <div class="d-flex caption justify-space-between">
              <div v-if="Number(saldo.is_saldo) === 1"> Sisa {{ saldo.sisa }} hari </div>
              <div v-else class="white--text"> &infin; </div>
              <div class="caption">
                <template v-if="saldo.tgl_mulai && saldo.tgl_selesai">
                  {{ saldo.tgl_mulai | toSDN }} -
                  {{ saldo.tgl_selesai | toSDN }}
                </template>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-col>
    <ChangeDlg ref="dlg" :kategoris="kategoriCuti" @reload="load" />
    <v-dialog close v-model="modalFilter" max-width="500">
      <v-card>
        <v-card-title class="headline-2 pl-4 mb-5 primary white--text"
          >Filter Berdasarkan
          <v-spacer></v-spacer>
          <v-btn id="toggleSelectAnggota" icon dark @click="modalFilter = false">
            <v-icon>mdi-close</v-icon>
          </v-btn></v-card-title
        >
        <v-card-text class="py-5">
          <v-form @submit.prevent data-vv-scope="form" lazy-validation>
            <v-row>
              <v-col v-if="tab !== 'ajuan'" cols="12" sm="12" md="12" lg="12" class="pa-1">
                <label class="caption mb-2 primary--text">Nama</label>
                <v-autocomplete
                  id="nama"
                  dense
                  single-line
                  outlined
                  editable="false"
                  :items="users"
                  name="user_id"
                  item-text="nama"
                  item-value="user_id"
                  label="Nama Anggota"
                  placeholder="Nama Anggota"
                  v-model="filters.user_id"
                  hint="Pilih Anggota"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12" class="pa-1">
                <label class="caption mb-2 primary--text">Kategori Cuti</label>
                <v-select
                  id="kategori"
                  dense
                  single-line
                  outlined
                  editable="false"
                  :items="kategoriCuti"
                  name="Kategori"
                  item-text="nama"
                  item-value="cuti_kategori_id"
                  label="Kategori Ketidakhadiran"
                  placeholder="Kategori Ketidakhadiran"
                  v-model="filters.cuti_kategori_id"
                  hint="Pilih Kategori"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="12" md="6" class="pa-1">
                <label class="caption mb-2 primary--text">Tanggal Awal</label>
                <m-datepicker
                  dense
                  single-line
                  outlined
                  label="Tanggal Mulai Cuti"
                  v-model="filters.tgl_awal"
                  hint="Tanggal Awal"
                ></m-datepicker>
              </v-col>
              <v-col cols="12" sm="12" md="6" class="pa-1">
                <label class="caption mb-2 primary--text">Tanggal Akhir</label>
                <m-datepicker
                  dense
                  single-line
                  outlined
                  label="Tanggal Akhir Cuti"
                  v-model="filters.tgl_akhir"
                  hint="Tanggal Akhir"
                ></m-datepicker>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions class="pr-4 pb-4">
          <v-btn depressed color="warning" @click="reset"> <v-icon>mdi-reload</v-icon>Reset </v-btn>
          <v-spacer></v-spacer>
          <v-btn id="filterStatus" name="simpan" depressed color="primary" @click="filter">
            <v-icon>mdi-check</v-icon>Terapkan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import ChangeDlg from '../components/FormAjuan.vue'
import BlockCard from '@/components/BlockCard'
// import { isCan } from '@/tools'
import { STATUS_AJUAN } from '@/modules/kategori/const'
import { countDate, duration } from '../../../tools'

export default {
  components: {
    ChangeDlg,
    BlockCard,
  },
  data() {
    return {
      items: [],
      modalFilter: false,
      cuti: {
        user_id: null,
        tanggalAwal: null,
        tanggalAkhir: null,
      },
      kategoriCuti: [],
      users: [],
      filters: {},
      textSearch: null,
      tab: 'ajuan',
      page: null,
      cp: 1,
      mStatus: STATUS_AJUAN,
      stat: {
        jenis_kelamin: { data: [], legend: [] },
        usia: { data: [], legend: [] },
      },
      more_menu: [
        {
          title: 'Detail',
          click: (i, o) =>
            this.$router.push({
              name: this.tab === 'ajuan' ? 'cuti.riwayat' : 'cuti.setuju',
              params: {
                organisasi_id: this.organisasi_id,
                cuti_id: o.cuti_id,
              },
            }),
        },
        {
          title: 'Ajukan',
          click: (i, o) => this.ajukan(o),
          check: (i, o) => Number(o.k_status) < 4 && this.tab === 'ajuan',
        },
        {
          title: 'Batal Ajuan',
          click: (i, o) => this.batalAjuan(o),
          check: (i, o) => [4].includes(Number(o.k_status)) && this.tab === 'ajuan',
        },
        {
          title: 'Hapus',
          click: (i, o) => this.hapus(o),
          check: (i, o) => Number(o.k_status) < 4 && this.tab === 'ajuan',
        },
      ],
    }
  },
  computed: {
    mKategoriCuti() {
      const items = this.kategoriCuti || []
      let temp = {}
      items.forEach((item) => {
        this.$set(temp, item.cuti_kategori_id, item.nama)
      })
      return temp
    },

    headers() {
      if (this.tab === 'ajuan') {
        return [
          { text: 'Kategori', align: 'left', value: 'nama', width: '30%' },
          { text: 'Keterangan', align: 'left', value: 'kategori' },
          { text: 'Status', align: 'left', value: 'keterangan' },
          { text: 'Tanggal Ajuan', align: 'left', value: 'tanggal' },
          { text: 'Aksi', align: 'center', sortable: false },
        ]
      } else {
        return [
          { text: 'Nama Karyawan', align: 'left', value: 'nama' },
          { text: 'Kategori', align: 'left', value: 'tipe', width: '25%' },
          { text: 'Keterangan', align: 'left', value: 'kategori' },
          { text: 'Status', align: 'left', value: 'status' },
          { text: 'Tanggal Ajuan', align: 'left', value: 'tanggal' },
          { text: 'Aksi', align: 'center', sortable: false },
        ]
      }
    },

    saldos() {
      let temp = this.kategoriCuti || []

      return temp.map((item) => {
        item.value = (item.sisa / item.total) * 100
        return item
      })
    },
  },
  activated() {
    this.load()
    this.loadKategori()
  },
  methods: {
    duration,
    countDate,
    load() {
      const api = this.tab === 'ajuan' ? 'cuti/getCutiKaryawan' : 'cuti/getPersetujuanKaryawan'
      this.$store
        .dispatch(api, {
          organisasi_id: this.organisasi_id,
          params: {
            page: this.cp,
            keyword: this.textSearch,
            cuti_kategori_id: this.filters.cuti_kategori_id,
            tgl_awal: this.filters.tgl_awal,
            tgl_akhir: this.filters.tgl_akhir,
            user_id: this.filters.user_id,
          },
        })
        .then((res) => {
          if (!this.allowLeave) this.$router.replace({ name: 'home' })
          this.page = res.data
          this.items = res.data.data
        })
        .catch((e) => e)

      if (this.tab === 'setuju') this.getUser()
    },
    loadKategori() {
      this.$store
        .dispatch('cuti/cekSaldo', {
          organisasi_id: this.organisasi_id,
        })
        .then(({ data }) => {
          this.kategoriCuti = data || []
        })
        .catch((e) => e)
    },
    add() {
      this.$refs.dlg.open()
    },
    edit(item) {
      this.$refs.dlg.open(item).then(() => {
        this.load()
      })
    },
    hapus(item) {
      this.$confirmDanger(
        `<div class="ma-1 mb-4 pa-1 row red lighten-4 red--text text--darken-4">

            <i class="ma-3 v-icon v-alert__icon mdi mdi-information-outline red--text text--darken-4"></i>

          <div class="col m11 pa-1">
            Pastikan Anda benar-benar mengerti apa yang Anda lakukan.
          </div>
        </div>

        <div class="mt-2">
                Apakah Anda yakin, akan menghapus data ajuan ini ?
        </div>

      `
      )
        .then(() =>
          this.$store.dispatch('cuti/drop', {
            organisasi_id: this.organisasi_id,
            cuti_id: `${item.cuti_id}/hapus-ajuan`,
          })
        )
        .then(() => {
          this.$info('Data berhasil dihapus')
        })
        .then(() => this.load())
        .catch((e) => e)
    },
    ajukan(item) {
      this.$confirmDanger(
        `Apakah Anda yakin akan mengajukan data ini ?<br>
        <div class="mt-2 grow">
          Tipe Cuti ${this.getDeepObj(item, 'keterangan')} pada Tanggal ${this.duration(
          item.tgl_awal,
          item.tgl_akhir
        )}<br>
        </div>
      `
      )
        .then(() =>
          this.$store.dispatch('cuti/actions', {
            organisasi_id: this.organisasi_id,
            obj: {
              url: `${item.cuti_id}/ajuan`,
            },
          })
        )
        .then(() => {
          this.$info('Data berhasil diajukan')
        })
        .then(() => this.load())
        .catch((e) => e)
    },
    batalAjuan(item) {
      this.$confirmDanger(
        `Apakah Anda yakin akan membatalkan data ajuan ini ?<br>
        <div class="mt-2 grow">
          Tipe Cuti ${this.getDeepObj(item, 'keterangan')} pada Tanggal ${this.duration(
          item.tgl_awal,
          item.tgl_akhir
        )}<br>
        </div>
      `
      )
        .then(() =>
          this.$store.dispatch('cuti/actions', {
            organisasi_id: this.organisasi_id,
            obj: {
              url: `${item.cuti_id}/batal-ajuan`,
            },
          })
        )
        .then(() => {
          this.$info('Data berhasil diajukan')
        })
        .then(() => this.load())
        .catch((e) => e)
    },
    onFilter() {
      this.modalFilter = true
    },
    filter() {
      this.cp = 1
      this.load()
      this.modalFilter = false
    },
    reset() {
      this.$set(this, 'filters', {})
    },
    getUser() {
      if (this.users.length > 0) return
      this.$store.dispatch('user/getUserAktif', { organisasi_id: this.organisasi_id }).then((res) => {
        this.users = [...res.data]
      })
    },
    onChangeTab(tipe) {
      this.page = 1
      this.tab = tipe
      this.load()
      if (tipe === 'setuju') {
        this.getUser()
      }
    },
  },
}
</script>
